/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
// import { BaseProvider } from 'baseui';
// import { Theme } from '../../Themes/index';
import { ISmartProps } from './types';
import { View } from './view';

export type TextareaProps = Omit<ISmartProps, 'css'>;

export const Textarea = React.forwardRef((props: TextareaProps, ref: any) => {
	return <View ref={ref} {...props} />;
});
